export function unwrapError(err) {
    if (typeof err === 'string') {
        try {
            const parsed = JSON.parse(err);
            if (parsed.message || parsed.error || parsed.reasons) {
                return `${parsed.message || parsed.reasons || parsed.error}`;
            }
        }
        catch (_e) {
            return err;
        }
    }
    if (Array.isArray(err)) {
        return err.map(unwrapError).join(', ');
    }
    if (typeof err === 'object' && err !== null) {
        if (Object.hasOwn(err, 'message')) {
            return unwrapError(err.message);
        }
    }
    return 'Unknown error';
}
